import { ThemeProvider, useTheme } from "styled-components";
import React from "react";
export const PaletteProvider = ({ children, palette }) => {
    const theme = useTheme();
    return (React.createElement(ThemeProvider, { theme: {
            skin: theme?.skin,
            palette: palette,
        } }, children));
};
export const withPalette = (Component) => {
    return (props) => {
        return (React.createElement(PaletteProvider, { palette: props.palette },
            React.createElement(Component, { ...props })));
    };
};
export const withPaletteContext = (Component) => {
    return (props) => {
        const paletteContext = useTheme();
        return (React.createElement(PaletteProvider, { palette: paletteContext.palette },
            React.createElement(Component, { ...props })));
    };
};
//# sourceMappingURL=PaletteProvider.js.map